import React, { useState, useRef, useEffect } from "react";
import sign_up from "../assets/images/sign_up.png";
import logo from "../assets/images/logo.png";
import apiClient from "../api/Apiservice";
import { BASE_URL } from "../api/devprofile";
import useLoginStatusStore from "../zustand/loginStatusStore";
import useUserDetailsStore from "../zustand/userDetailsStore";
import SignupAlert from "./SignupAlert";
import ListPropertyAlert from "./ListPropertyAlert";

interface ListPropertyProps {
  isOpen: boolean;
  onClose: () => void;
}
interface UserInterface {
  firstName: string;
  lastName: string;
  mobile: string;
  email: string;
  notificationMode: string[];
  userId: string;
}

export default function ListProperty({ isOpen, onClose }: ListPropertyProps) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    address: "",
    pinCode: "",
    propertyName: "",
  });
  const [mobileError, setMobileError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const { setUserDetails } = useUserDetailsStore();
  const { setUserMobile, setIsLoginStatus, setUseruuId, useruuId } =
    useLoginStatusStore();
  const [userData, setUserData] = useState<UserInterface | {}>({});
  const [isOpenListAlert, setIsOpenListAlert] = useState(false);

  const modalRef = useRef<HTMLDivElement>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let value = e.target.value;

    if (["firstName", "lastName"].includes(e.target.name)) {
      value = value.replace(/[^a-zA-Z\s]/g, "");
      value = value.replace(/^\s+/, "");
      value = value.replace(/\s+/g, " ");
      value = value.replace(/(\s)(?=\s)/g, "");
    } else if (e.target.name === "mobile") {
      value = value.replace(/[^0-9]/g, "");
    }

    setFormData({ ...formData, [e.target.name]: value });
  };

  const getUserDetails = async (mobile: number, email: string) => {
    try {
      if (email) {
        const { data, status } = await apiClient.get(
          `${BASE_URL}/zoy_customer/getUser/${mobile}?email=${email}`
        );

        return data;
      }
    } catch (error) {
      // console.error("Error fetching user details in use auth:", error);
    }
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await getUserDetails(
          Number(formData.mobile),
          formData.email
        );
        setUserData(response || {});
        if (response) {
          setUserDetails(response);
        } else {
          // console.error("No user details found.");
        }
      } catch (error) {
        // console.error("Error fetching user details:", error);
      }
    };
    // if (!screenName.includes('RegisterScreen')) {
    fetchUserDetails();
    // }
  }, [formData.mobile]);

  const registerData = {
    firstname: formData.firstName,
    lastname: formData.lastName,
    email: formData.email,
    mobile: formData.mobile,
    address: formData.address,
    pincode: formData.pinCode,
    propertyName: formData.propertyName,
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Validate mobile number
    if (/^[0-5]/.test(formData.mobile)) {
      setMobileError("Invalid Mobile Number");
      return;
    }

    setMobileError(null);
    const response = await apiClient.get(
      `${BASE_URL}/zoy_customer/checkPhoneNumber/${formData.mobile}`
    );
    const message = response.data.message;

    if (message === "Phone number exists") {
      alert("Mobile Number already exists");
    } else {
      console.log(
        `${BASE_URL}/zoy_partner/regesteredPartnerDetails`,
        registerData
      );
      const { data, status } = await apiClient.post(
        `${BASE_URL}/zoy_partner/regesteredPartnerDetails`,
        registerData
      );
      console.log(data.data, "::::::data.data");
      console.log(status, "::::::::::status");
      const id = data.data;
      setUseruuId(id);
      setUserMobile(formData.mobile);
      setIsLoginStatus(true);
      if (status === 200 || status === 201) {
        // Close the registration modal
        setIsOpenListAlert(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          address: "",
          pinCode: "",
          propertyName: "",
        });
      }
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setIsOpenListAlert(false);
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    setIsOpenListAlert(false);
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="flex flex-row h-[550px] overflow-hidden" ref={modalRef}>
          <div className="rounded-l-2xl">
            <img src={sign_up} alt="signUp" className="h-full w-[340px]" />
          </div>
          <div className="bg-white p-6 rounded-r-2xl shadow-lg w-96 relative">
            {/* Close Button */}
            <button
              className="absolute right-4 text-gray-600"
              onClick={handleClose}
            >
              ✖
            </button>

            {/* Logo */}
            <div className="flex justify-center z-10">
              <img src={logo} alt="Logo" className="h-32" />
            </div>

            <h2 className="text-center text-xl font-bold mt-2">
              List your property with ZOY
            </h2>

            {/* Signup Form */}
            <form
              onSubmit={handleSubmit}
              className="mt-4 max-h-[500px] overflow-y-auto pb-44 pr-3"
              style={{
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE and Edge
              }}
            >
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                className="w-full p-2 mt-2 border rounded-md"
                required
                maxLength={50}
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                className="w-full p-2 mt-2 border rounded-md"
                required
                maxLength={50}
              />

              <input
                type="email"
                name="email"
                placeholder="E-mail"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-2 mt-2 border rounded-md"
                required
              />

              <input
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full p-2 mt-2 border rounded-md"
                required
                maxLength={10}
              />

              {mobileError && (
                <p className="text-red-500 text-sm mt-1">{mobileError}</p>
              )}

              <textarea
                name="address"
                placeholder="Enter Your Address"
                value={formData.address}
                onChange={handleChange}
                className="w-full p-2 mt-2 border rounded-md"
                required
                rows={2}
              ></textarea>

              <input
                type="text"
                name="pinCode"
                placeholder="Enter PIN Code"
                value={formData.pinCode}
                onChange={handleChange}
                className="w-full p-2 mt-2 border rounded-md"
                required
                maxLength={6}
              />

              <textarea
                name="propertyName"
                placeholder="Enter Your Property Name"
                value={formData.propertyName}
                onChange={handleChange}
                className="w-full p-2 mt-2 border rounded-md"
                required
                rows={2}
              ></textarea>

              <button
                type="submit"
                className="w-full mt-4 p-2 bg-pink-500 text-white rounded-md"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <ListPropertyAlert
        isOpenListAlert={isOpenListAlert}
        onClose={() => setIsOpenListAlert(false)}
      />
    </>
  );
}
